<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Grade Step</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <!-- <vs-button
              @click="editGrade"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            > -->
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />

           <div class="vx-row p-5" v-if="gradeDescription.campaign_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Campaign:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ gradeDescription.campaign_name }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="gradeDescription.step_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Step:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ gradeDescription.step_name }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="gradeDescription.step_description">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Description:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ gradeDescription.step_description }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="gradeDescription.order_by">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Order:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ gradeDescription.order_by }}
          </div>
        </div>

            <div class="vx-row p-5">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Fields:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
          <div class="mb-4" v-for="f in gradeDescription.field">
            {{ f }}
            <br class="mt-5">
          </div>
          </div>
        </div>
       
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import defineAbilitiesFor from "@/config/abilities";
import _ from "lodash";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
      configDateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      abilities: null,
      gradeDescription: [],
      grade_step_id: null
    };
  },
  components: {
    "v-select": vSelect,
    moduleGradeManagement,
        flatPickr

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule(
        "GradesManagement",
        moduleGradeManagement
      );
      moduleGradeManagement.isRegistered = true;
    }
  },
  mounted() {
    this.grade_step_id = this.$route.params.gradeStepId;
    this.fetchGradeStep();
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    fetchGradeStep() {
      this.$store
        .dispatch("GradesManagement/fetchGradeStep", this.grade_step_id)
        .then(res => {
          let result = JSON.parse(res.data);
          this.gradeDescription = result[0]
          // console.log(this.gradeDescription[0])
        })
        .catch(err => {
          console.error(err);
        });
    },
    editGrade() {
      this.$router.push({ path: `/grade-step/edit/${this.grade_step_id}` });
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
